import React, { Fragment } from "react";
import ReactTooltip from "react-tooltip";

export default function Tooltip({
  iconClass = "fa fa-info",
  id,
  type = "info",
  place = "top",
  children,
}) {
  return (
    <Fragment>
      <span data-tip data-for={id} className="badge">
        <i className={iconClass} />
      </span>
      <ReactTooltip id={id} type={type} effect="solid" place={place}>
        <div style={{ width: 300 }}>{children}</div>
      </ReactTooltip>
    </Fragment>
  );
}
